import { Pipe, PipeTransform } from "@angular/core";
import { UtilsService } from "@core/services/utils/utils.service";

@Pipe({
  name: "domainFromUrl",
  pure: true
})
export class DomainFromUrlPipe implements PipeTransform {
  transform(url: string | null | undefined): string {
    if (!url) {
      return "";
    }

    return UtilsService.getDomainFromUrl(url);
  }
}
